import styled from 'styled-components';

export const MainDashboardContainerStyled = styled.div`
  .loading_layout {
    height: calc(100vh - 186px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title_layout {
    margin-bottom: 19px;
  }
  .section_introduce_layout {
    margin-bottom: 22px;
  }
`;
